<template>
  <v-app>
    <Appbar />
    <v-main>
      <Information />
      <div class="pa-4">
        <div class="mb-5 px-4 mt-4">
          <v-layout
            :style="`height: 60px;background-color: ${backgroundColor}`"
            align-center
            class="ma-0 pa-0"
            d-flex
            justify-start
          >
            <div
              :style="`width:5px; height:100%;background-color:${accentColor}`"
              class="mr-4"
            />
            <div style="font-weight: bold;font-size: 18px;">
              利用規約
            </div>
          </v-layout>
        </div>

        <v-card
          class="ma-4 mt-8 pa-8"
          flat
          style="border-radius: 8px"
        >
          <v-btn
            outlined
            class="mb-4"
            to="/aboutpayments"
          >
            プレミアムプランの詳細についてはこちらをご確認ください
          </v-btn>
          <div class="message">
            <p>
              2021/03/12変更
            </p>
            <p>
              第7条3項を削除しました。
              削除前の記載は下記の通りです。<br>
              ”利用者は、利用者が本ツールによって作成した全ての創作物に関する著作権（著作権法第27条、第28条の権利を含みます）について、運営者に対して無償で許諾するものとし、著作者人格権を行使しないものとします。”
            </p>
          </div>
          <p>
            NOVEWRITE利用規約（以下「本規約」といいます）は、快適に小説を書くためのエディターツール「NOVEWRITE」（以下「本ツール」といいます）の運営者（以下「運営者」といいます）が、本ツールの利用条件等について定めたものです。
            本ツールを利用するお客様（以下「利用者」といいます）は、あらかじめ本規約を承諾した上で、本ツールを利用するものとします。
          </p>
          <p>
            第１条（本規約等）
          </p>
          <p>
            1
            利用者は、あらかじめ本規約及び運営者の定める個人情報保護に関する方針（以下「プライバシーポリシー」といいます）を承諾のうえ、Googleアカウント又はTwitterアカウント（以下「アカウント」といいます）を利用して、運営者所定のWebサイト（以下「当Webサイト」といいます）又は運営者所定のアプリケーション（以下「当アプリ」といいます）にログインをすることによって、本ツールを利用することができるものとし、運営者は、利用者が本ツールを利用したときは、本規約及びプライバシーポリシーを承諾したとみなすものとします。
          </p>
          <p>
            2
            運営者は、１つのアカウントにつき、１人の利用者のみの利用を認めるものとし、複数人による１アカウントの共有、利用、使い回し等は禁じるものとします。かかる利用状況が検知された場合、運営者は、当該利用者について、直ちに第５条第２項の措置を行うことができるものとします。
          </p>
          <p>
            3
            運営者は、第４条に定めた利用料を支払う利用者（以下「有料会員」といいます）の代金の精算に関する業務については、原則として、運営者指定の決済代行会社に委託するため、有料会員は、同決済代行会社の決済システムを利用するために、クレジットカード決済に必要となるカード番号、有効期限、セキュリティコードを決済代行会社に登録する等必要な手続きをあわせて行うものとします。
          </p>
          <p>
            4
            運営者は、本規約の内容について、必要に応じて変更することができるものとします。この場合、運営者が変更後の本規約を所定の場所に公表するものとします。ただし、利用者に不利益が生じる変更については、あらかじめ利用者に通知を行うものとします。
          </p>
          <p>
            第２条（本ツール）
          </p>
          <p>
            1 本ツールは、利用者が小説その他の文章を執筆することをサポートするために、主に以下の機能を備えたツールとなります。
          </p>
          <p>
            ① 小説その他の文章のライティング機能
          </p>
          <p>
            ② 前号によって執筆した文章の構成、編集、記録、保存、管理機能
          </p>
          <p>
            ③ その他運営者が適宜追加する機能
          </p>
          <p>
            2 利用者は、当アプリによって前項各号の機能を利用できるものとしますが、以下の機能については、有料会員のみが利用できるものとします。
          </p>
          <p>
            ① 当Webサイトにおける前項各号の機能の利用
          </p>
          <p>
            ② 当アプリと当サイト間のデータ同期機能
          </p>
          <p>
            ③ 第５項の運営者指定のバナー広告等を非表示とする機能
          </p>
          <p>
            ④ その他運営者が定めた機能
          </p>
          <p>
            3
            利用者は、利用者の入力した文字によって構成されるコンテンツデータ及び利用者がアップロードした画像データ（以下「コンテンツデータ」といいます）が、本ツールを通じて運営者所定のサーバー等に一定期間保存されることについて、あらかじめ異議なく承諾するものとします。
          </p>
          <p>
            4
            利用者は、いつでも本ツールの利用を解約することができるものとします。ただし、有料会員は、利用料が決済される24時間前を経過した以降に解約した場合は、当該利用料を支払わなければならないものとし、運営者は、当該利用料の返金には応じないものとします。
          </p>
          <p>
            5 運営者は、本ツール内に、運営者指定のバナー広告等を表示することがありますが、これらについて、利用者は、自己の責任において利用するものとします。
          </p>
          <p>
            第３条（禁止行為）
          </p>
          <p>
            利用者は、本ツールの利用にあたって、以下の行為をしてはならないものとし、運営者がかかる行為に該当すると判断したコンテンツデータを予告なく削除することについて、異議を述べないものとします。
          </p>
          <p>
            ①
            第三者の著作権、商標権等の知的財産権を侵害する行為、又は侵害するおそれのある行為（他者の著作物を引用する場合において出典を明示しないまま引用を行う行為含む）
          </p>
          <p>
            ② 第三者の財産、プライバシー若しくは肖像権を侵害する行為、又は侵害するおそれのある行為
          </p>
          <p>
            ③ 第三者を不当に差別若しくは誹謗中傷し、不当な差別を助長し、又はその名誉若しくは信用を毀損する行為
          </p>
          <p>
            ④ 詐欺行為、薬物濫用、児童売買春、違法な取引、生命・身体・財産を脅かす犯罪についての現実の危険に結びつくおそれが高い行為
          </p>
          <p>
            ⑤
            児童ポルノ又は児童虐待に相当するコンテンツデータについて、投稿又は表示し、収録した媒体を販売し、収録した媒体の送信、表示、販売を想起させる広告を投稿又は表示する行為
          </p>
          <p>
            ⑥ 年少者の閲覧に際し不適切と考えられるコンテンツデータについて適切な注意喚起をしない行為
          </p>
          <p>
            ⑦ 有害なコンピュータプログラム等を流布させることを目的とするサイト等にリンクを貼る行為
          </p>
          <p>
            ⑧
            運営者のサーバーに対して過度に負担をかける行為、本ツールの運営やネットワークシステムに支障を与える行為、いわゆるスパム行為、及びこれらのおそれのある行為
          </p>
          <p>
            ⑨ 法令、公序良俗に違反する行為の他、運営者が不適切と判断する行為
          </p>
          <p>
            第４条（利用料）
          </p>
          <p>
            1 有料会員は、運営者が定めて本ツール内に公表した月払い利用料又は年払い利用料について、運営者所定の時期に支払うものとします
          </p>
          <p>
            2 前項の支払い方法は、運営者指定の決済事業者を通じて、クレジットカードによって決済するものとします。
          </p>
          <p>
            3 利用料の返金は、できないものとします。ただし、運営者が特に認めた場合は、この限りではありません。
          </p>
          <p>
            第５条(本ツールの停止等)
          </p>
          <p>
            1 運営者は、運営者の本ツールの提供環境が以下の各号いずれかに該当する場合、予告なく、本ツールの全部又は一部の提供を停止することができるものとします。
          </p>
          <p>
            ① 緊急でコンピュータシステムの点検、保守を行う場合
          </p>
          <p>
            ② 停電、サーバー故障等が発生した場合
          </p>
          <p>
            ③ コンピュータ、通信回線等に不良がある場合
          </p>
          <p>
            ④ 地震、落雷、火災等の不可抗力による場合
          </p>
          <p>
            ⑤ その他運営者が必要と判断した場合
          </p>
          <p>
            2
            運営者は、利用者が本規約の一つにでも違反するおそれを認めた場合、予告なく当該利用者に対する本ツールの提供を停止すると共に、利用資格を喪失させることができるものとします。
          </p>
          <p>
            3
            運営者は、前二条によって利用者に生じた損害について、いかなる責任も負わないものとします。また、運営者は前条によって運営者に生じた損害について、利用者及び利用者であった者に対して請求することができるものとします。
          </p>
          <p>
            第６条(免責事項)
          </p>
          <p>
            1
            運営者は、コンテンツデータの内容自体についてはいかなる関与もしないため、その正確性、適法性、適切性、倫理性、無害性、安全性等については何ら保証をせず、何らの責任も負わないものとします。また、コンテンツデータについて、利用者と第三者との間に発生したトラブル、クレーム、紛争等については、利用者の責任と費用によって解決するものとし、運営者は、いかなる責任も負わないものとします。
          </p>
          <p>
            2
            運営者は、コンテンツデータについて、利用者のアカウントの有効な期間内及び運営者所定の期間内に限り、一時的に保存することがありますが、かかる期間経過後においては、運営者の裁量により削除するものとします。運営者は、利用者によるコンテンツデータのバックアップ作成等を行う義務は一切負わないものとし、利用者であった者から過去のコンテンツデータの復旧希望があったとしても、かかる希望に応える義務は一切負わないものとします。
          </p>
          <p>
            3
            運営者は、運営者が一般的なサービス業者として措置する程度のセキュリティ対策を実施している場合において、なお回避が困難なウィルスやマルウェア等によって利用者に損害が生じたとしても、いかなる責任も負わないものとします。
          </p>
          <p>
            4
            運営者は、利用者の機器や通信回線等の障害、エラー、バグの発生等についていかなる責任も負わず、かかる状況等により利用者又は第三者に生じた損害について、いかなる責任も負わないものとします。
          </p>
          <p>
            5
            本規約に定めた運営者を免責する全ての条項については、運営者に故意又は重過失が存する場合には適用しないものとします。また、本規約のいずれかの条項の一部が民法、消費者契約法その他の法令により無効、取消、差し止めとなった場合であっても、残部の条項は継続して完全に効力を有するものとします。
          </p>
          <p>
            第７条(権利の帰属)
          </p>
          <p>
            1
            本ツールの表示にかかる著作権、商標権、意匠権、肖像権その他一切の権利については、本ツールに使用される以前から利用者又は第三者に帰属していたものを除き、全て運営者又は運営者に許諾した権利者に帰属するものとします。
          </p>
          <p>
            2
            利用者は、前項に基づき、本ツールにおける運営者に帰属する権利を含む情報について、運営者に無断で使用、転用、転載、複製等を行ってはならないものとします。
          </p>
          <p>
            3
            利用者は、利用者が本ツールによって作成した全ての創作物について、第三者の権利を侵害していないことを保証するものとし、第三者との間におけるトラブル、紛争等については、全て自らの費用と責任において解決するものとします。
          </p>
          <p>
            第８条（反社会的勢力排除）
          </p>
          <p>
            1
            利用者は、自らが暴力団、暴力団員、暴力団準構成員、暴力団関係企業、総会屋等社会運動標榜ゴロ又は特殊知能暴力団、その他これらに準ずる者(以下これらを「反社会的勢力」といいます）に該当しないこと、及び次の各号のいずれにも該当しないことを表明し、かつ将来にわたっても該当しないことを確約します。
          </p>
          <p>
            ① 反社会的勢力が経営を支配していると認められる関係を有すること
          </p>
          <p>
            ② 反社会的勢力が経営に実質的に関与していると認められる関係を有すること
          </p>
          <p>
            ③
            自己、自社若しくは第三者の不正の利益を図る目的又は第三者に損害を加える目的をもってするなど、不当に反社会的勢力を利用していると認められる関係を有すること
          </p>
          <p>
            ④ 反社会的勢力に資金等を提供し、又は便宜を供与するなどの関与をしていると認められる関係を有すること
          </p>
          <p>
            ⑤ 役員又は経営に実質的に関与している者が反社会的勢力と社会的に非難されるべき関係を有すること
          </p>
          <p>
            2 利用者は、自ら又は第三者を利用して次の各号の一つにでも該当する行為を行わないことを確約します。
          </p>
          <p>
            ① 暴力的な要求行為
          </p>
          <p>
            ② 法的な責任を超えた不当な要求行為
          </p>
          <p>
            ③ 取引に関して、脅迫的な言辞又は暴力を用いる行為
          </p>
          <p>
            ④ 風説を流布し、偽計若しくは威力を用いて相手方の信用を毀損し、又は業務を妨害する行為
          </p>
          <p>
            第９条（個人情報の取扱い）
          </p>
          <p>
            運営者は、利用者の個人情報の取扱いについて、プライバシーポリシーに従って行うものとします。
          </p>
          <p>
            第10条（法解釈、管轄合意）
          </p>
          <p>
            1 本規約は、日本法に基づき解釈されるものとします。
          </p>
          <p>
            2 本規約に関して訴訟の必要が生じた場合には、訴額に応じて、運営者の住所地を管轄する地方裁判所又は簡易裁判所を第一審の専属的合意管轄裁判所とします。
          </p>
        </v-card>
      </div>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import Footer from '../component/Footer.vue';
import Appbar from '../component/Appbar.vue';
import Information from "@/component/Information";

export default {
  name: "Terms",
  components: {
    Footer,
    Appbar,
    Information
  },
  data() {
    return {
      accentColor: null,
      backgroundColor: null,
    }
  },
  mounted() {
    this.accentColor = this.$vuetify.theme.themes.light.secondary
    this.backgroundColor = this.$vuetify.theme.dark ? 'black' :
        'white'
  },
}
</script>

<style scoped>
.message {
  border: var(--v-background-base) solid 1px;
  margin: 12px;
  padding: 12px 8px 0px;
  font-size: 13px;
}
</style>